/* KORI purchase flow: localized bundle pricing and one add request per submission. */
(()=>{
 'use strict';
 const boot=()=>{
  const dataNode=document.getElementById('KoriCheckoutData');
  if(!dataNode)return;
  let config;try{config=JSON.parse(dataNode.textContent)}catch(e){return}
  const lang=(config.locale||'de').split('-')[0];
  const copy={
   de:{starter:'Starter-Set',stock:'Vorrats-Set',single:'Einmaliger Kauf',shipping:'Kostenloser Versand',save:'Du sparst',versus:'gegenüber zwei Starter-Sets',loading:'Weiter zur Kasse …',error:'Das Hinzufügen hat nicht funktioniert. Bitte versuche es erneut.'},
   pl:{starter:'Zestaw na start',stock:'Zestaw na zapas',single:'Zakup jednorazowy',shipping:'Darmowa dostawa',save:'Oszczędzasz',versus:'w porównaniu z dwoma zestawami na start',loading:'Przechodzimy do kasy…',error:'Nie udało się dodać produktu. Spróbuj ponownie.'},
   cs:{starter:'Startovací sada',stock:'Sada do zásoby',single:'Jednorázový nákup',shipping:'Doprava zdarma',save:'Ušetříte',versus:'oproti dvěma startovacím sadám',loading:'Přecházíme k pokladně…',error:'Produkt se nepodařilo přidat. Zkuste to znovu.'},
   sk:{starter:'Štartovacia súprava',stock:'Súprava do zásoby',single:'Jednorazový nákup',shipping:'Doprava zadarmo',save:'Ušetríte',versus:'oproti dvom štartovacím súpravám',loading:'Prechádzame k pokladni…',error:'Produkt sa nepodarilo pridať. Skúste to znova.'},
   fr:{starter:'Duo découverte',stock:'Lot de 4',single:'Achat unique',shipping:'Livraison offerte',save:'Économisez',versus:'par rapport à deux duos découverte',loading:'Redirection vers le paiement…',error:'Impossible d’ajouter le produit. Veuillez réessayer.'},
   nl:{starter:'Starterset',stock:'Voordeelset',single:'Eenmalige aankoop',shipping:'Gratis verzending',save:'Je bespaart',versus:'ten opzichte van twee startersets',loading:'Doorgaan naar afrekenen…',error:'Het toevoegen is niet gelukt. Probeer het opnieuw.'}
  }[lang]||null;
  if(!copy)return;
  const root=(config.root||'/').replace(/\/$/,'');
  const checkout=root+'/checkout';
  const money=value=>{const currency=config.currency||'EUR';const digits=['PLN','CZK'].includes(currency)&&value%100===0?0:2;return new Intl.NumberFormat(lang,{style:'currency',currency,minimumFractionDigits:digits,maximumFractionDigits:2}).format(value/100)};
  document.querySelectorAll('[data-kori-money]').forEach(el=>{const value=Number(el.dataset.koriMoney);if(Number.isFinite(value))el.textContent=money(value)});
  const variants=config.variants||[];
  document.querySelectorAll('.kori-purchase').forEach(form=>{
   form.dataset.koriDirectCheckout='';
   let redirect=form.querySelector('[name="return_to"]');
   if(!redirect){redirect=document.createElement('input');redirect.type='hidden';redirect.name='return_to';form.append(redirect)}
   redirect.value=checkout;
   form.querySelectorAll('.kori-offer').forEach((label,i)=>{
    const variant=variants[i];if(!variant)return;
    const input=label.querySelector('[name="id"]');if(input)input.value=variant.id;
    const content=label.querySelector('input + span');
    if(content){
     const title=document.createElement('strong');title.textContent=i===0?copy.starter:copy.stock;
     const details=document.createElement('small');details.textContent=`${i===0?2:4} × 50 ml · ${copy.single}`;
     const shipping=document.createElement('small');shipping.className='kori-save';shipping.textContent=copy.shipping;
     content.replaceChildren(title,details);
     if(i===1&&variants[0]){const saving=variants[0].price*2-variant.price;if(saving>0){const line=document.createElement('small');line.className='kori-save';line.textContent=`${copy.save} ${money(saving)} ${copy.versus}`;content.append(line)}}
     content.append(shipping);
    }
    const price=label.querySelector('.kori-offer-price');if(price){const strong=document.createElement('b');strong.textContent=money(variant.price);price.replaceChildren(strong)}
   });
  });
  const pending=new WeakSet();
  document.addEventListener('submit',async event=>{
   const form=event.target;if(!(form instanceof HTMLFormElement))return;
   const action=new URL(form.action,location.href);
   if(action.origin!==location.origin||! /\/cart\/add(?:\.js)?\/?$/.test(action.pathname)||!form.querySelector('[name="id"]'))return;
   event.preventDefault();event.stopImmediatePropagation();
   if(pending.has(form))return;
   pending.add(form);
   const button=event.submitter||form.querySelector('[type="submit"]');const original=button?.textContent;
   const fields=new FormData(form);fields.delete('return_to');
   form.querySelector('.kori-purchase-error')?.remove();
   if(button){button.disabled=true;button.textContent=copy.loading}form.setAttribute('aria-busy','true');
   try{
    const response=await fetch(action.pathname.replace(/\.js\/?$/,'').replace(/\/$/,'')+'.js',{method:'POST',body:fields,headers:{Accept:'application/json'},credentials:'same-origin'});
    if(!response.ok)throw new Error('add_failed');
    await response.json();
    location.assign(checkout);
   }catch(error){
    pending.delete(form);form.removeAttribute('aria-busy');if(button){button.disabled=false;button.textContent=original}
    const message=document.createElement('p');message.className='kori-purchase-error';message.setAttribute('role','alert');message.textContent=copy.error;form.append(message);
   }
  },true);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
